import LocalizedStrings from 'localized-strings';

import { PREMIUM_CARD_NAME } from 'helpers/paymentCards/constants';

const locales = new LocalizedStrings({
  en: {
    claimButton: {
      intercomMessage:
        'Hi, I would like to benefit from the hardware warranty\n',
    },
    content: {
      exclude: {
        items: [
          "Breakdowns occurring before the end of the manufacturer's warranty.",
          'Faults resolved using accessible adjustments without taking the device apart.',
          'Mobile phones coverage',
        ],
        title: 'This coverage does not include',
      },
      include: {
        items: [
          `Up to €1,500 per repair, once per year, for any equipment worth over €75 only when purchased **with your ${PREMIUM_CARD_NAME}**.`,
          "If a repair is not possible, you'll be reimbursed the purchase price of an equivalent product.",
          'Depreciation (obsolescence) of 1% is applied per month you own the product.',
          'Coverage extended to your employees.',
        ],
        title: 'This coverage includes',
      },
    },
    similarOffersTitle: 'Other insurances related to your coverage',
    title: 'Extended equipment warranty',
  },
  fr: {
    claimButton: {
      intercomMessage:
        'Bonjour, je souhaiterais bénéficier de la garantie matérielle\n',
    },
    content: {
      exclude: {
        items: [
          'Les pannes survenues avant la fin de la garantie constructeur.',
          'Les pannes résolues à partir des réglages accessibles sans démontage de l’appareil.',
          'La couverture des téléphones mobiles',
        ],
        title: 'Cette garantie n’inclut pas',
      },
      include: {
        items: [
          `Jusqu’à 1 500\xa0€ par réparation, une fois par an, pour tout équipement d’une valeur supérieure à 75\xa0€ acheté **avec la carte ${PREMIUM_CARD_NAME} uniquement**.`,
          'En cas d’irréparabilité, remboursement au prix d’achat d’un bien équivalent.',
          'Une dépréciation (vétusté) de 1\xa0% par mois de détention du produit concerné est appliquée.',
          'La couverture étendue à vos employé·es.',
        ],
        title: 'Cette garantie inclut',
      },
    },
    similarOffersTitle: 'Autres assurances liées à votre couverture',
    title: 'Extension de garantie',
  },
} as const);

export default locales;
